import type { Article } from "../hooks/useArticles";
import type { NewsItem } from "../mocks/news";

const FALLBACK_IMAGE = "https://readdy.ai/api/search-image?query=dramatic%20commercial%20aircraft%20silhouette%20against%20sunset%20sky%20aviation%20photography%20dark%20moody%20cinematic%20wide%20angle&width=800&height=600&seq=fallback-article&orientation=landscape";

export function toNewsItem(article: Article): NewsItem {
  const cat = article.category || "";
  const tags = Array.isArray(article.tags) ? article.tags : [];
  // Las categorías secundarias se guardan dentro de `tags` (junto a la principal).
  // Derivamos la lista visible excluyendo la categoría principal y "Internacional"
  // (que tiene su propio badge), y sumamos el campo legado `subcategory` (ej: subcategorías de Turismo).
  const secondaryCategories = Array.from(
    new Set([
      ...tags.filter((t) => t && t !== cat && t !== "Internacional"),
      ...(article.subcategory &&
      article.subcategory !== cat &&
      article.subcategory !== "Internacional"
        ? [article.subcategory]
        : []),
    ]),
  );
  return {
    id: article.id,
    title: article.title || "",
    excerpt: article.excerpt || "",
    category: article.category || "",
    categoryColor: article.category_color || "bg-slate-500",
    author: article.author || "",
    date: article.date || "",
    readTime: article.read_time || "1 min",
    image: article.image || FALLBACK_IMAGE,
    featured: article.featured || false,
    slug: article.slug || "",
    views: article.views || 0,
    isInternational: article.is_international || false,
    tags,
    subcategory: article.subcategory || undefined,
    secondaryCategories,
  };
}

export function toNewsItems(articles: Article[]): NewsItem[] {
  return articles.map(toNewsItem);
}